/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-01 14:14:54
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-01 14:15:06
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/ProductSet/Dimensions/ProductSetDimensionsSection.tsx
 */
import React from 'react';
import Dimensions from '../../Components/Dimensions/Dimensions';
import { useSelector } from 'react-redux';
import { setDimensions } from '../slice';
import { reducer } from '../../tools/dataDict';
import { EnumProductType } from 'src/types/common/product';
const DimensionsSection = (props) => {
  const dimensions = useSelector((state: any) => state.productSet.dimensions);

  // const dimensionsOnChange = (setting) => {
  //   dispatch(setDimensions(setting));
  // };
  return (
    <Dimensions
      disabled={props.disabled}
      reducer={reducer[EnumProductType.Set]}
      setDimensions={setDimensions}
      measurementUnits={[]}
      data={dimensions}
      // dimensionsOnChange={dimensionsOnChange}
    />
  );
};
export default DimensionsSection;
